import axios from "axios";
import auth from "./interceptors/auth";
import producer from "./interceptors/producer";
import deviceId from "./interceptors/device-id";
import version from "./interceptors/version";
import logout from "./interceptors/logout";

const api = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(auth);
api.interceptors.request.use(producer);
api.interceptors.request.use(deviceId);
api.interceptors.request.use(version);
api.interceptors.response.use(undefined, logout);

export default api;
